import type { JSX } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SortableTableHeaders } from '@/shared/components/SortableTableHeaders';
import type { SortState } from '@/shared/types/table-filters.types';
import { CandidateRow } from './CandidateRow';
import type {
  JobPositionCandidateWithDetails,
  ApplicationStatus,
} from '../../types/jobPositionCandidate.types';

interface JobPositionCandidatesTableProps {
  candidates: JobPositionCandidateWithDetails[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onStatusChange: (candidateId: string, status: ApplicationStatus) => void;
  onUnlink: (candidateId: string, candidateName: string) => void;
  isUpdating: boolean;
}

const SORTABLE_HEADERS = [
  { key: 'candidateName', label: 'Candidate', className: 'w-[250px]' },
  { key: 'applicationStatus', label: 'Status', className: 'w-[150px]' },
  { key: 'appliedAt', label: 'Applied', className: 'w-[120px]' },
  { key: 'notes', label: 'Notes' },
];

export function JobPositionCandidatesTable({
  candidates,
  sort,
  onToggleSort,
  ...rowHandlers
}: JobPositionCandidatesTableProps): JSX.Element {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <SortableTableHeaders
              headers={SORTABLE_HEADERS}
              sort={sort}
              onToggleSort={onToggleSort}
            />
            <TableHead className="w-[60px] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {candidates.map((candidate) => (
            <CandidateRow key={candidate.id} candidate={candidate} {...rowHandlers} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
